import { render, staticRenderFns } from "./MasterpieceSelect.vue?vue&type=template&id=48386be8&scoped=true&"
import script from "./MasterpieceSelect.vue?vue&type=script&lang=js&"
export * from "./MasterpieceSelect.vue?vue&type=script&lang=js&"
import style0 from "./MasterpieceSelect.vue?vue&type=style&index=0&id=48386be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48386be8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Hint: require('/home/bitrix/frontend/components/other/Hint.vue').default,ItemCard: require('/home/bitrix/frontend/components/gallery/ItemCard.vue').default,MasterpieceSelectItem: require('/home/bitrix/frontend/components/profile/MasterpieceSelectItem.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MasterpieceSelectBottom: require('/home/bitrix/frontend/components/profile/MasterpieceSelectBottom.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
